'use client';

/**
 * Client-side UI components boundary for Next.js App Router
 * All components from @insforge/react are re-exported here with 'use client' directive
 */

// Main components
export {
  SignIn,
  SignUp,
  ForgotPassword,
  ResetPassword,
  VerifyEmail,
  UserButton,
  Protect,
  SignedIn,
  SignedOut,
  SignInButton,
  SignUpButton,
} from '@insforge/react/components';

// Form components
export {
  SignInForm,
  SignUpForm,
  ForgotPasswordForm,
  ResetPasswordForm,
  VerifyEmailStatus,
} from '@insforge/react/components';

// Atom components
export {
  AuthBranding,
  AuthContainer,
  AuthHeader,
  AuthErrorBanner,
  AuthFormField,
  AuthPasswordField,
  AuthPasswordStrengthIndicator,
  AuthSubmitButton,
  AuthLink,
  AuthDivider,
  AuthOAuthButton,
  AuthOAuthProviders,
  AuthVerificationCodeInput,
  AuthEmailVerificationStep,
  AuthResetPasswordVerificationStep,
} from '@insforge/react/components';

// Re-export all component types
export type {
  SignInProps,
  SignUpProps,
  ForgotPasswordProps,
  ResetPasswordProps,
  VerifyEmailProps,
  UserButtonProps,
  ProtectProps,
  ConditionalProps,
  SignInFormProps,
  SignUpFormProps,
  ForgotPasswordFormProps,
  ResetPasswordFormProps,
  VerifyEmailStatusProps,
  AuthContainerProps,
  AuthHeaderProps,
  AuthErrorBannerProps,
  AuthFormFieldProps,
  AuthPasswordFieldProps,
  AuthPasswordStrengthIndicatorProps,
  AuthSubmitButtonProps,
  AuthLinkProps,
  AuthDividerProps,
  AuthOAuthButtonProps,
  AuthOAuthProvidersProps,
  AuthVerificationCodeInputProps,
} from '@insforge/react/components';
